import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// @ts-ignore
import BillingSectionHeader from '@/components/Billing/BillingSectionHeader.vue';
import { SECTION_DESCRIPTION, HOW_IT_WORKS_EXPLANATIONS, LEARN_MORE_LINK } from '@/components/Billing/billing-service.const';
import { ProductType } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerFeaturesSectionHeader',
  setup(__props) {

const productType = ProductType.CustomerFeatures;
const subTitle = computed(() => SECTION_DESCRIPTION[productType]);
const learnMoreLink = computed(() => LEARN_MORE_LINK[productType]);
const howItWorksExplanations = computed(() => HOW_IT_WORKS_EXPLANATIONS[productType]);

return { __sfc: true,productType, subTitle, learnMoreLink, howItWorksExplanations, BillingSectionHeader }
}

})